/* @flow */
import invariant from 'invariant';
import * as React from 'react';

import ToastActions from 'actions/ToastActions';
import CurrentUser from 'auth/CurrentUser';
import Button from 'components/Button';
import ClipboardTrigger from 'components/ClipboardTrigger';
import Container from 'components/Container';
import FormSingle from 'components/FormSingle';
import Input from 'components/Input';
import Label from 'components/Label';
import Row from 'components/Row';
import TextWithGlyph from 'components/TextWithGlyph';
import TitleHeader from 'components/TitleHeader';
import LinkConstants from 'constants/LinkConstants';
import Group from 'entities/Group';
import GroupAvatar from 'groups/components/GroupAvatar';
import getPrettyUrl from 'utils/getPrettyUrl';

import './UsersShareJoinUrl.scss';

type Props = {
  group: Group,
};

export default class UsersShareJoinUrl extends React.Component<Props> {
  showCopyToast(): void {
    ToastActions.showSuccessToast('URL has been copied to your clipboard');
  }

  render() {
    const { group } = this.props;

    const joinUrl = group.getJoinUrl();

    invariant(joinUrl, 'UsersShareJoinUrl missing joinUrl');

    const emailSubject = encodeURIComponent(
      `Accept request to join ${group.getName()} with ${CurrentUser.getUser().getSignature()}`
    );
    const emailBody = encodeURIComponent(
      `I’m using Remind to send important updates, assignments, and information for ${group.getName()}. Please click on the link below to join our class. (For reference, our class code is @${group.getCodeOrError()}.)\n\r${joinUrl}\n\rThanks for joining!\n\r${CurrentUser.getUser().getSignature()}\n\rP.S. Remind is a free, safe, and easy way for me to reach you with important information. Want to learn more? Go here: ${
        LinkConstants.WHAT_IS_REMIND
      }`
    );

    const referralUrl = group.getJoinUrl();
    const referralUrlPretty = getPrettyUrl(referralUrl);

    return (
      <div className="UsersShareJoinUrl">
        <TitleHeader
          title="Share this link any way you like!"
          subtext="This link includes your class code, so anyone who has it can join your class instantly."
        />
        <Container size="xsmall">
          <Row>
            <div className="UsersShareJoinUrl-image">
              <GroupAvatar group={group} className="UsersShareJoinUrl-image-avatar" />
            </div>
          </Row>
          <Row size="small">
            <FormSingle>
              <div>
                <Label hidden>URL</Label>
                <Input readOnly value={referralUrlPretty} />
              </div>
              <ClipboardTrigger text={referralUrl} onCopy={this.showCopyToast}>
                <Button level="secondary" size="xsmall">
                  Copy link
                </Button>
              </ClipboardTrigger>
            </FormSingle>
          </Row>
          <Button
            href={`mailto:?subject=${emailSubject}&body=${emailBody}`}
            target="_blank"
            full
            size="small"
            eventElementName="email-link-button">
            <TextWithGlyph glyph="email" glyphSize="medium" inline>
              Email link
            </TextWithGlyph>
          </Button>
        </Container>
      </div>
    );
  }
}
